import React from 'react';
import { IMultimedia } from '../../Models/Multimedia/IMultimedia';

interface MultimediaPreviewProps {
    multimedia: IMultimedia;
    onClick?: React.MouseEventHandler;
    big?: boolean;
}

export default function MultimediaPreview({
    multimedia,
    onClick,
    big = false,
}: MultimediaPreviewProps) {
    const date = new Date(multimedia.creationDate);
    const isBig = big ? '--big' : '';

    const truncatedDescription =
        multimedia.description && multimedia.description.length > 140
            ? multimedia.description.substring(0, 140) + '...'
            : multimedia.description;

    return (
        <div
            onClick={onClick}
            className={`w-100 d-flex flex-column border h-100 media-preview${isBig}`}
            style={{ cursor: 'pointer' }}
        >
            <div
                className={`media--items__image${isBig}`}
                style={{ backgroundImage: `url(${multimedia.thumbnailUrl})` }}
            />
            <div
                className={
                    big
                        ? 'media--items__title d-flex h-100 align-items-end'
                        : 'title-desc-container w-100'
                }
            >
                <div className={`title-desc ${big ? 'mb-5' : 'p-4 w-100'}`}>
                    <h3
                        className={big ? 'media--items__big-title' : 'm-0 mb-5'}
                    >
                        {multimedia.title}
                    </h3>

                    {truncatedDescription && (
                        <span className={big ? 'mt-n4' : 'mt-n5'}>
                            {truncatedDescription}
                        </span>
                    )}
                </div>
                <div className="date">
                    {date.toLocaleDateString()}
                    {multimedia.readingTime !== 0 && (
                        <>
                            &nbsp;- <i className="icon-clock"></i>{' '}
                            {multimedia.readingTime}min.
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
